import { FileText } from "lucide-react";
import HeroSection from "./components/HeroSection";
import FeatureSection from "./components/FeatureSection";

const Home = () => {
  const features = [
    {
      title: "AI Resume Parsing",
      description: "Automatically extracts skills, experience, and education from any resume format.",
      icon: FileText,
    },
    {
      title: "Smart Matching",
      description: "Scores candidates against job requirements using an AI-powered matching engine.",
      icon: FileText,
    },
    {
      title: "Auto Shortlisting",
      description: "Qualified candidates above threshold scores are shortlisted instantly.",
      icon: FileText,
    },
    {
      title: "Interview Prep",
      description: "AI generates tailored interview questions for every shortlisted candidate.",
      icon: FileText,
    },
  ];

  return (
    <>
      {/* Hero Section */}
      <HeroSection />

      {/* Features Section */}
      <FeatureSection features={features} />
    </>
  );
};

export default Home;
